import styled, { css } from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

import type { ButtonProps } from 'components/Button';
import { Button } from 'components/Button';

import type { GdprRestrictedButtonVariant } from './GdprRestrictedButton';

export const StyledLink = styled.a`
  display: block;
  color: ${colorsPalettes.blue[300]};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${colorsPalettes.blue[400]};
  }
`;

export const StyledButton = styled(Button)<
  {
    restrictedVariant: GdprRestrictedButtonVariant;
  } & ButtonProps
>`
  padding: 4px 12px;

  ${({ restrictedVariant }) =>
    (restrictedVariant === 'bulk-export' || restrictedVariant === 'bulk-reveal') &&
    css`
      font-size: 10.5px;
      line-height: 15px;
      padding: 8px 13px;
    `}
`;
